import {RoleGuard} from '../../services/guards/role-guard.service';
import {NotFoundComponent} from '../not-found/not-found.component';
import {HomeComponent} from './home/home.component';
import {ProductHomePageComponent} from './product-home-page/product-home-page.component';
import {RequestDetailsComponent} from './request-details/request-details.component';

export const ExternalEmployeeRoutes = [
  {
    path: 'external-employee',
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate: [RoleGuard],
        data: {role: 'external-employee'}
      },
      {
        path: ':productName',
        component: ProductHomePageComponent,
        canActivate: [RoleGuard],
        data: {role: 'external-employee'}
      },
      {
        path: ':productName/:id',
        component: RequestDetailsComponent,
        canActivate: [RoleGuard],
        data: {role: 'external-employee'}
      },
      {
        path: '**',
        component: NotFoundComponent
      }
    ]
  }
];
